module.exports = __webpack_public_path__ + "images/1850f736.img4-usa.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img4-usa.png
// module id = 410
// module chunks = 0